// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.ultimate-security-dashboard-content {
  background-color: #ffffff;
  padding: 30px;
}
.ultimate-security-dashboard-content .dash-card {
  border-radius: 6px;
  border: 1px solid #D8D9DB;
  max-width: unset;
}
.ultimate-security-dashboard-content .card-body {
  padding: 1rem;
}
.ultimate-security-dashboard-content .card-body.p-4 {
  padding: 1.5rem !important;
}
.ultimate-security-dashboard-content .card-title {
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 1.5rem;
}
.ultimate-security-dashboard-content .stat-card {
  display: flex;
  align-items: center;
}
.ultimate-security-dashboard-content .failed-login-attempt {
  border: 10px solid #6BD2D1;
  border-radius: 100%;
}
.ultimate-security-dashboard-content .icon-circle {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-right: 1rem;
}
.ultimate-security-dashboard-content .icon-circle .stat-content .stat-value {
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 0.25rem;
}
.ultimate-security-dashboard-content .icon-circle .stat-content .stat-label {
  font-size: 0.875rem;
  color: #6c757d;
  margin-bottom: 0;
}
.ultimate-security-dashboard-content .icon-circle .status-indicator {
  display: flex;
  align-items: center;
}
.ultimate-security-dashboard-content .icon-circle .status-indicator .status-text h4 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}
.ultimate-security-dashboard-content .icon-circle .status-indicator .status-text p {
  margin-bottom: 0;
  color: #6c757d;
}
.ultimate-security-dashboard-content .icon-circle .list-unstyled {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}
.ultimate-security-dashboard-content .icon-circle .list-unstyled li {
  position: relative;
  padding-left: 1.25rem;
  margin-bottom: 0.75rem;
}
.ultimate-security-dashboard-content .icon-circle .list-unstyled li:last-child {
  margin-bottom: 0;
}
.ultimate-security-dashboard-content .icon-circle .list-unstyled li:before {
  content: "•";
  position: absolute;
  left: 0;
}
.ultimate-security-dashboard-content .icon-circle .header-with-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
.ultimate-security-dashboard-content .icon-circle .header-with-link .card-title {
  margin-bottom: 0;
}
.ultimate-security-dashboard-content .icon-circle .header-with-link .view-link {
  color: #6f42c1;
  text-decoration: none;
  font-size: 0.875rem;
}
.ultimate-security-dashboard-content .icon-circle .header-with-link .view-link:hover {
  text-decoration: underline;
}
.ultimate-security-dashboard-content .icon-circle .card-stack {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.ultimate-security-dashboard-content .file-status-result {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1%;
  text-align: center;
  color: #ffffff;
  padding: 20px;
  border-radius: 3px;
}
.ultimate-security-dashboard-content .option-enabled-dash-card .score-area {
  background-color: #873EFF;
  padding: 24px;
  border-radius: 3px;
}
.ultimate-security-dashboard-content .option-enabled-dash-card .score-area .option-enabled-header .score {
  color: #FFFFFF;
  font-weight: 600;
  font-size: 36px;
  line-height: 34px;
  letter-spacing: 1%;
  margin-bottom: 4px;
}
.ultimate-security-dashboard-content .option-enabled-dash-card .score-area .option-enabled-header .unit {
  color: #6BD2D1;
  font-weight: 600;
  font-size: 14;
  line-height: 20px;
  letter-spacing: 1%;
}
.ultimate-security-dashboard-content .option-enabled-dash-card .score-area .option-enabled-footer {
  display: flex;
  align-items: center;
  gap: 4;
  color: #FFFFFF;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1%;
}
.ultimate-security-dashboard-content .dashboard-item {
  height: 51%;
  padding: 24px;
}

.file-list-wrapper .modalHeader {
  padding: 24px;
  border-bottom: 1px solid #D8D9DB;
}
.file-list-wrapper .modalHeader .modalTitle {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1%;
  margin: 0;
  margin-bottom: 4px;
  color: #000000;
}
.file-list-wrapper .modalHeader .modalIntro {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1%;
  margin-bottom: 12px;
  color: #000000;
}
.file-list-wrapper .modalHeader .modalHelp {
  background-color: #D1C1FF;
  border: 1px solid #5007AA;
  padding: 10px 12px;
  color: #5007AA;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1%;
}
.file-list-wrapper .datatable-unit {
  padding: 30px;
}
.file-list-wrapper .datatable-unit .datatable-filters span {
  color: #000000;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1%;
  display: block;
  cursor: pointer;
}
.file-list-wrapper .datatable-unit .datatable-filters span + span {
  border-left: 1px solid rgba(29, 35, 39, 0.5019607843);
  margin-left: 8px;
  padding-left: 8px;
}
.file-list-wrapper .datatable-unit .datatable-filters span.active {
  color: #5007AA;
}
.file-list-wrapper .datatable-unit .search-unit input {
  background: #FFFFFF;
  border: 1px solid #D8D9DB;
  border-radius: 3px;
}
.file-list-wrapper .datatable-unit .search-unit .button-secondary {
  border: 1px solid #873EFF;
  color: #873EFF;
  padding: 8px 12px;
  background-color: transparent;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1%;
  text-align: center;
  border-radius: 3px;
}
.file-list-wrapper .datatable-unit .table-wrapper {
  margin-top: 30px;
}
.file-list-wrapper .datatable-unit .rdt_TableHeadRow, .file-list-wrapper .datatable-unit .rdt_Pagination {
  background-color: #FFFDEE;
}
.file-list-wrapper .datatable-unit .rdt_TableHeadRow {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1%;
  padding-top: 10px;
  padding-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Dashboard.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAgBhB;EACC,yBAAA;EACG,aAAA;AAdJ;AAgBC;EACC,kBAdmB;EAenB,yBAAA;EACM,gBAAA;AAdR;AAiBC;EACC,aAlBY;AAGd;AAiBE;EACC,0BAAA;AAfH;AAoBC;EACC,mBAAA;EACA,gBAAA;EACA,qBA5Be;AAUjB;AAqBC;EACC,aAAA;EACA,mBAAA;AAnBF;AAsBI;EACI,0BAAA;EACA,mBAAA;AApBR;AAuBC;EACC,WAvCU;EAwCV,YAxCU;EAyCV,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAjDY;AA4Bd;AA0BG;EACC,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AAxBJ;AA2BG;EACC,mBAAA;EACA,cAAA;EACA,gBAAA;AAzBJ;AA6BE;EACC,aAAA;EACA,mBAAA;AA3BH;AA8BI;EACC,iBAAA;EACA,gBAAA;EACA,sBAAA;AA5BL;AA+BI;EACC,gBAAA;EACA,cAAA;AA7BL;AAkCE;EACC,gBAAA;EACA,eAAA;EACA,gBAAA;AAhCH;AAkCG;EACC,kBAAA;EACA,qBAAA;EACA,sBAAA;AAhCJ;AAkCI;EACC,gBAAA;AAhCL;AAmCI;EACC,YAAA;EACA,kBAAA;EACA,OAAA;AAjCL;AAsCE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBA/Gc;AA2EjB;AAsCG;EACC,gBAAA;AApCJ;AAuCG;EACC,cA/HM;EAgIN,qBAAA;EACA,mBAAA;AArCJ;AAuCI;EACC,0BAAA;AArCL;AA0CE;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AAxCH;AA4CC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AA1CF;AA6CE;EACC,yBAAA;EACA,aAAA;EACA,kBAAA;AA3CH;AA6CI;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AA3CL;AA6CI;EACC,cAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AA3CL;AA8CG;EACC,aAAA;EACA,mBAAA;EACA,MAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA5CJ;AAgDC;EACC,WAAA;EACA,aAAA;AA9CF;;AAoDC;EACC,aAAA;EACA,gCAAA;AAjDF;AAkDE;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;AAhDH;AAkDE;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAhDH;AAkDE;EACC,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAhDH;AAmDC;EACC,aAAA;AAjDF;AAmDG;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAjDJ;AAkDI;EACC,qDAAA;EACA,gBAAA;EACA,iBAAA;AAhDL;AAkDI;EACC,cAAA;AAhDL;AAqDG;EACC,mBAAA;EACA,yBAAA;EACA,kBAAA;AAnDJ;AAqDG;EACC,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAnDJ;AAsDE;EACC,gBAAA;AApDH;AAsDE;EACC,yBAAA;AApDH;AAsDE;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AApDH","sourcesContent":["// WordPress Security Dashboard styles\n$primary: #6f42c1;\n$danger: #dc3545;\n$dark: #212529;\n$info: #20c997;\n\n// Card variables\n$card-border-radius: 6px;\n$card-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n$card-spacer: 1rem;\n$card-spacer-lg: 1.5rem;\n\n// Icon variables\n$icon-size: 50px;\n$icon-size-lg: 64px;\n\n.ultimate-security-dashboard-content {\n\tbackground-color: #ffffff;\n    padding: 30px;\n\n\t.dash-card {\n\t\tborder-radius: $card-border-radius;\n\t\tborder: 1px solid #D8D9DB;\n        max-width: unset;\n\t}\n\n\t.card-body {\n\t\tpadding: $card-spacer;\n\n\t\t&.p-4 {\n\t\t\tpadding: $card-spacer-lg !important;\n\t\t}\n        \n\t}\n\n\t.card-title {\n\t\tfont-size: 1.125rem;\n\t\tfont-weight: 500;\n\t\tmargin-bottom: $card-spacer-lg;\n\t}\n\n\t.stat-card {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\n    .failed-login-attempt{\n        border: 10px solid #6BD2D1;\n        border-radius: 100%;\n    }\n\n\t.icon-circle {\n\t\twidth: $icon-size;\n\t\theight: $icon-size;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tborder-radius: 50%;\n\t\tmargin-right: $card-spacer;\n\n\t\t\n\n\t\t.stat-content {\n\t\t\t.stat-value {\n\t\t\t\tfont-size: 1.75rem;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tline-height: 1;\n\t\t\t\tmargin-bottom: 0.25rem;\n\t\t\t}\n\n\t\t\t.stat-label {\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t\tcolor: #6c757d;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\n\t\t.status-indicator {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t.status-text {\n\t\t\t\th4 {\n\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tmargin-bottom: 0.25rem;\n\t\t\t\t}\n\n\t\t\t\tp {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\tcolor: #6c757d;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.list-unstyled {\n\t\t\tlist-style: none;\n\t\t\tpadding-left: 0;\n\t\t\tmargin-bottom: 0;\n\n\t\t\tli {\n\t\t\t\tposition: relative;\n\t\t\t\tpadding-left: 1.25rem;\n\t\t\t\tmargin-bottom: 0.75rem;\n\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: \"•\";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.header-with-link {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\tmargin-bottom: $card-spacer-lg;\n\n\t\t\t.card-title {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\n\t\t\t.view-link {\n\t\t\t\tcolor: $primary;\n\t\t\t\ttext-decoration: none;\n\t\t\t\tfont-size: 0.875rem;\n\n\t\t\t\t&:hover {\n\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.card-stack {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 1.5rem;\n\t\t}\n\t}\n\t\n\t.file-status-result {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tfont-weight: 700;\n\t\tfont-style: Bold;\n\t\tfont-size: 16px;\n\t\tline-height: 24px;\n\t\tletter-spacing: 1%;\n\t\ttext-align: center;\n\t\tcolor: #ffffff;\n\t\tpadding: 20px;\n\t\tborder-radius: 3px;\n\t}\n\t.option-enabled-dash-card {\n\t\t.score-area {\n\t\t\tbackground-color: #873EFF;\n\t\t\tpadding: 24px;\n\t\t\tborder-radius: 3px;\n\t\t\t.option-enabled-header {\n\t\t\t\t.score {\n\t\t\t\t\tcolor: #FFFFFF;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tfont-size: 36px;\n\t\t\t\t\tline-height: 34px;\n\t\t\t\t\tletter-spacing: 1%;\n\t\t\t\t\tmargin-bottom: 4px;\n\t\t\t\t}\n\t\t\t\t.unit {\n\t\t\t\t\tcolor: #6BD2D1;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tfont-size: 14;\n\t\t\t\t\tline-height: 20px;\n\t\t\t\t\tletter-spacing: 1%;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.option-enabled-footer {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tgap: 4;\n\t\t\t\tcolor: #FFFFFF;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 24px;\n\t\t\t\tletter-spacing: 1%;\n\t\t\t}\n\t\t}\n\t}\n\t.dashboard-item {\n\t\theight: 51%;\n\t\tpadding: 24px;\n\t}\n}\n\n\n.file-list-wrapper {\n\t.modalHeader {\n\t\tpadding: 24px;\n\t\tborder-bottom: 1px solid #D8D9DB;\n\t\t.modalTitle {\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 24px;\n\t\t\tletter-spacing: 1%;\n\t\t\tmargin: 0;\n\t\t\tmargin-bottom: 4px;\n\t\t\tcolor: #000000;\n\t\t}\n\t\t.modalIntro {\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 20px;\n\t\t\tletter-spacing: 1%;\n\t\t\tmargin-bottom: 12px;\n\t\t\tcolor: #000000;\n\t\t}\n\t\t.modalHelp {\n\t\t\tbackground-color: #D1C1FF;\n\t\t\tborder: 1px solid #5007AA;\n\t\t\tpadding: 10px 12px;\n\t\t\tcolor: #5007AA;\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 20px;\n\t\t\tletter-spacing: 1%;\n\t\t}\n\t}\n\t.datatable-unit {\n\t\tpadding: 30px;\n\t\t.datatable-filters {\n\t\t\tspan {\n\t\t\t\tcolor: #000000;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 24px;\n\t\t\t\tletter-spacing: 1%;\n\t\t\t\tdisplay: block;\n\t\t\t\tcursor: pointer;\n\t\t\t\t+ span {\n\t\t\t\t\tborder-left: 1px solid #1D232780;\n\t\t\t\t\tmargin-left: 8px;\n\t\t\t\t\tpadding-left: 8px;\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\tcolor: #5007AA;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.search-unit {\n\t\t\tinput {\n\t\t\t\tbackground: #FFFFFF;\n\t\t\t\tborder: 1px solid #D8D9DB;\n\t\t\t\tborder-radius: 3px;\n\t\t\t}\n\t\t\t.button-secondary {\n\t\t\t\tborder: 1px solid #873EFF;\n\t\t\t\tcolor: #873EFF;\n\t\t\t\tpadding: 8px 12px;\n\t\t\t\tbackground-color: transparent;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 24px;\n\t\t\t\tletter-spacing: 1%;\n\t\t\t\ttext-align: center;\n\t\t\t\tborder-radius: 3px;\n\t\t\t}\n\t\t}\n\t\t.table-wrapper {\n\t\t\tmargin-top: 30px;\n\t\t}\n\t\t.rdt_TableHeadRow,.rdt_Pagination {\n\t\t\tbackground-color: #FFFDEE;\n\t\t}\n\t\t.rdt_TableHeadRow {\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 24px;\n\t\t\tletter-spacing: 1%;\n\t\t\tpadding-top: 10px;\n\t\t\tpadding-bottom: 10px;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
